import { ValidationItemContainer } from "../../../reporting/report-lists/reports/copyto/CompanyMultipleReportsListItemContainer.tsx";
import type { SelectedCompanyTile } from "../../hooks/validationStateSlice";
import { ReportValidated } from "./index.ts";

interface ReportNotConfiguredProps {
  companyTile: SelectedCompanyTile;
}

export const ReportNotConfigured = ({ companyTile }: ReportNotConfiguredProps) => {
  return (
    <ValidationItemContainer
      caption={companyTile.tile.widget.nameUserInput || "(No name)"}
      active={false}
      completed={true}
      selectable
      onSelected={() => {}}
      TopAction={undefined}
    >
      <ReportValidated companyTile={companyTile} />
    </ValidationItemContainer>
  );
};
